import moment from "moment";
import { Link } from "react-router-dom";

import {
  Badge,
  CopyButton,
  CurrencyDisplay,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";
import { appConfig } from "../../configs";
import {
  IViewVirtualAccountTransferRefund,
  StatusColors,
} from "../../interfaces-and-types";
import {
  getVirtualAccountTransferRefundStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";
import { paymentIssueTypes } from "../../enums";

export const virtualAccountTransferRefundsDisplayFormatter = (
  item: IViewVirtualAccountTransferRefund
) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getVirtualAccountTransferRefundStatusIndicator(item);

  const amountTransferredCalculated =
    item.payment_issue_type === paymentIssueTypes.amountIncomplete ||
    item.payment_issue_type === paymentIssueTypes.duplicatePayment
      ? Number(item.refund_amount)
      : Number(item.refund_amount) + Number(item.charged_amount);

  return {
    ...item,
    tx_ref: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <Link
          to={`/payments/${item.transaction_id}/details`}
          className="transaction-id-text modal-header--title"
        >
          {/* <div className="transaction-id-text modal-header--title"> */}
          <span title={item.tx_ref}>
            {truncateStringWithEllipsis(item.tx_ref, 8)}
          </span>
          {/* </div> */}
        </Link>

        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-reference-button"
            stringToCopy={item.tx_ref}
            iconDescription="copy reference"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    refund_amount: (
      <CurrencyDisplay
        currencyOrSymbol={"NGN" /*item.currency*/}
        amount={item.refund_amount}
      />
    ),
    amount: !item.amount ? (
      "N/A"
    ) : (
      <CurrencyDisplay
        currencyOrSymbol={"NGN" /*item.currency*/}
        amount={Number(item.amount)}
      />
    ),
    amount_paid: !item.amount_paid ? (
      "N/A"
    ) : (
      <CurrencyDisplay
        currencyOrSymbol={"NGN" /*item.currency*/}
        amount={Number(item.amount_paid)}
      />
    ),
    charged_amount: !item.charged_amount ? (
      "N/A"
    ) : (
      <CurrencyDisplay
        currencyOrSymbol={"NGN" /*item.currency*/}
        amount={Number(item.charged_amount)}
      />
    ),
    amount_transferred: (
      <CurrencyDisplay
        currencyOrSymbol={"NGN" /*item.currency*/}
        amount={amountTransferredCalculated}
      />
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    refund_reason: <strong>{item.refund_reason || "..."}</strong>,
    customer_email: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.customer_email}>
            {truncateStringWithEllipsis(item.customer_email, 5) ||
              "(anonymous)"}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            stringToCopy={item.customer_email}
            iconDescription="copy customer email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    gateway: !item.gateway_code ? (
      "-"
    ) : (
      <img
        src={`${process.env.PUBLIC_URL}/gateway-logos/${item.gateway_code}-icon.svg`}
        alt="gateway logo"
        className="gateway-icon--small align-self--center"
        title={item.gateway_code}
      />
    ),
    date: (
      <span className="date--oneline">
        {moment(
          item.is_refund_completed
            ? item.edited_at ?? item.created_at
            : item.created_at
        ).format(appConfig.dateTimeFormat)}
      </span>
    ),
    more: (
      <OverflowMenuDropDown
        focusTrap={false}
        data-floating-menu-container
        size="sm"
        flipped
      >
        <OverflowMenuDropDownItem
          index={1}
          itemText="Manage Payment Issue"
          href={`virtual-account-transfer-refunds/${item.id}/details`}
        />
        {/* <OverflowMenuDropDownItem
              index={1}
              itemText="Edit"
              onClick={item.openEditModal}
            />
            <OverflowMenuDropDownItem
              index={2}
              itemText={""}
              onClick={item.archivePaymentLink}
              hasDivider
            />
            {item.isAmountIncomplete || item.isAmountExcess ? null : (
              <OverflowMenuDropDownItem
                index={3}
                hasDivider
                isDelete
                itemText="Refund To Customer"
                onClick={item.refundToCustomer}
              />
            )} */}
      </OverflowMenuDropDown>
    ),
  };
};
